<div id="ticket-sticky" class="is-tri ticket-sticky visible-xs" [ngClass]="{ show: showSticky }">
    <div class="box">
        <div class="columns is-mobile is-aligned-center">
            @if (showDaily) {
                <div class="column has-text-centered">
                    <div class="text is-level-2 has-text-weight-semibold">Aujourd'hui</div>
                    <trg-price
                        [price]="prices.DAILY"
                        [inheritFontSize]="true"
                        [isInlined]="true"
                        [size]="'text is-level-3'"
                    />
                </div>
            }
            @if (showFunding) {
                <div class="column has-text-centered">
                    <div class="text is-level-2 has-text-weight-semibold">Financement</div>
                    <trg-price
                        [price]="fundingPrice"
                        class="is-margin"
                        [isInlined]="true"
                        [hasPeriod]="true"
                        [inheritFontSize]="true"
                        [size]="'text is-level-3'"
                    />
                </div>
            }
            @if (showMonthly) {
                <div class="column has-text-centered">
                    <div class="text is-level-2 has-text-weight-semibold">Offre</div>
                    <trg-price
                        [price]="prices.MONTHLY"
                        [isInlined]="true"
                        [hasPeriod]="true"
                        [inheritFontSize]="true"
                        [size]="'text is-level-3'"
                    />
                </div>
            }
            <div class="column is-2">
                @if (!noButtons && formData) {
                    <div class="buttons is-centered">
                        <button
                            role="button"
                            [attr.aria-label]="'Continuer'"
                            [ngClass]="{ 'is-loading': formData.loading }"
                            [disabled]="formData.invalid"
                            class="button is-conversion"
                            (click)="goToNextStep()"
                        >
                            <span class="icon is-small icon-cart has-text-secondary is-marginless">
                                <i class="tri-shopping-cart"></i>
                            </span>
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
